export const SET_STATISTICS = "STATISTICS_SET_STATISTICS";
export const SET_ERROR = "STATISTICS_SET_ERROR";
export const SET_FETCHING = "STATISTICS_SET_FETCHING";
